import type { Link } from 'storyblok-schema'

// A plain e-mail address with no scheme or path, e.g. entered into a URL link.
const BARE_EMAIL_ADDRESS = /^[^\s@/:?#]+@[^\s@/:?#]+$/

/**
 * Converts the storyblok internal object to DOM properties (href, target and handles anchors)
 *
 * ```jsx
 * <Component {...storyblokLink(link)} />
 * ```
 */
export function storyblokLink(link?: Pick<Link, 'anchor' | 'cached_url' | 'linktype' | 'target'>): {
  href: string
  target?: string
} {
  if (!link) return { href: '' }

  const { anchor, cached_url, linktype, target } = link
  const href = cached_url + (anchor ? '#' + anchor : '')

  // A bare address as href would resolve relative to the page (a 404).
  if (linktype === 'email' || BARE_EMAIL_ADDRESS.test(href)) {
    return { href: `mailto:${href}`, target }
  }

  if (linktype === 'story') {
    return { href: href.startsWith('/') ? href : `/${href}`, target }
  }

  return { href, target }
}
